import React from 'react'
//import PropTypes from 'prop-types'
import './style.css';
import MCProfileMenu from '../../_common/ProfileMenu';


const MCEadTopBar = (props) => {

    const {
        avatarProfile,
        nameProfile,
        onRouteClick,
        context,
    } = props

    return (
        <div className='mc-ead-navbar'>
             <div>

            </div> 

            <div>
                <MCProfileMenu avatarProfile={avatarProfile}
                               nameProfile={nameProfile}
                               onRouteClick={onRouteClick}
                               context={context}
                />
            </div>

        </div>
    )
}

MCEadTopBar.propTypes = {

}

MCEadTopBar.defaultProps = {

}

export default MCEadTopBar



// WEBPACK FOOTER //
// ./src/components/_ead/TopBar/index.js